__turbopack_context__.v({
  "address": "venueCard-module-scss-module__zMWWwa__address",
  "description": "venueCard-module-scss-module__zMWWwa__description",
  "details": "venueCard-module-scss-module__zMWWwa__details",
  "image_wrapper": "venueCard-module-scss-module__zMWWwa__image_wrapper",
  "meta": "venueCard-module-scss-module__zMWWwa__meta",
  "more": "venueCard-module-scss-module__zMWWwa__more",
  "name": "venueCard-module-scss-module__zMWWwa__name",
  "top": "venueCard-module-scss-module__zMWWwa__top",
  "wrapper": "venueCard-module-scss-module__zMWWwa__wrapper",
});
